/* eslint-disable @typescript-eslint/no-explicit-any */

import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type DesubscribirViajesResponse = {
  state: number;
  value: any;
};

export const desubscribirViajes = async (): Promise<any> => {
  try {
    const res = await apiClient.post<DesubscribirViajesResponse>(
      Endpoints.DesubscribirViajes,
      {}
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
